import { render, staticRenderFns } from "./ImageUploadButton.vue?vue&type=template&id=f55823fe"
import script from "./ImageUploadButton.vue?vue&type=script&lang=ts"
export * from "./ImageUploadButton.vue?vue&type=script&lang=ts"
import style0 from "./ImageUploadButton.vue?vue&type=style&index=0&id=f55823fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports